import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "PointerText"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10.2825 9.2175L5.5575 4.5H9.75V3H3V9.75H4.5V5.5575L9.2175 10.2825L10.2825 9.2175ZM12.75 11.25H16.5C17.3284 11.25 18 11.9216 18 12.75V18.75H13.5C12.6716 18.75 12 18.0784 12 17.25V15.75C12 14.9216 12.6716 14.25 13.5 14.25H16.5V12.75H12.75V11.25ZM13.5 17.25H16.5V15.75H13.5V17.25ZM9 22.5H21C21.8284 22.5 22.5 21.8284 22.5 21V9C22.5 8.17157 21.8284 7.5 21 7.5H13.5V9H21V21H9V13.5H7.5V21C7.5 21.8284 8.17157 22.5 9 22.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/PointerText.vue"]]);
